import { Feature } from 'ol';
import { Units } from 'ol/control/ScaleLine';
import WKT from 'ol/format/WKT';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector';
import olMap from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import Style from 'ol/style/Style';
import * as olProj from 'ol/proj';


export class MapGazetteer {

    private baseUrl: string = "/api/mapsearch";
    private twuuidApiUrl: string = "/api/twuidsearch";

    //array of points - used when user selects an option from the search results dropdown
    private searchResults = new Array();

    //hard coded id of dropdownlist, this could be passed in
    private resultsSelectId: string = "#gazetterSelect";
    private searchBoxId: string = "#txtSearch";
    private searchBtnId: string = "#btnSearch";
    private searchTwuidBoxId: string = "#txtTwuidSearch";
    private searchTwuidBtnId: string = "#btnTwuidSearch";

    private vectorLayer: VectorLayer;
    private vectorSource: VectorSource;

    public constructor(private map: olMap) {
        map = this.map;
        this.addHandlers();
        this.addVectorLayer();
    }

    private addVectorLayer = (): void => {
        this.vectorSource = new VectorSource({});
        this.vectorLayer = new VectorLayer({
            source: this.vectorSource
        });
        this.map.addLayer(this.vectorLayer);
    }

    private hideSearchResultBox = (): void => {
        let resultsSelect = $(this.resultsSelectId);
        resultsSelect.empty();
        resultsSelect.hide();
    }

    private addHandlers = (): void => {
        let self = this;

        $(".hasclear").keyup(function () {
            let t = $(this);
            t.next('span').toggle(Boolean(t.val()));
        });

        $(".clearer").hide({
                complete: function () {
                    $(this).prev('input').val();
                }
            }            
        );

        $(".clearer").click(function (e) {
            $(this).prev('input').val('').focus();
            $(this).hide();
            let resultsSelect = $(self.resultsSelectId);
            resultsSelect.empty();
            resultsSelect.hide();
            $("#noResults").hide();
            self.clearMarker();
        });

        $(this.resultsSelectId).change(function (event) {
            self.showOnMap($(this));
        });

        //Location/Postcode
        $(this.searchBtnId).click(function (event) {
            self.search();
        });
        $(this.searchBoxId).keypress(function (event) {
            if (event.which || event.keyCode) {
                if ((event.which == 13) || (event.keyCode == 13)) {
                    self.search();
                    return false;
                }
            }
            return true;
        });

        //Twuid
        $(this.searchTwuidBtnId).click(function (event) {
            self.searchTwuid();
        });
        $(this.searchTwuidBoxId).keypress(function (event) {
            if (event.which || event.keyCode) {
                if ((event.which == 13) || (event.keyCode == 13)) {
                    self.searchTwuid();
                    return false;
                }
            }
            return true;
        });
    }

    private search = (): void => {
        this.clearMarker();

        //trim it
        $(this.searchBoxId).val((<string>$(this.searchBoxId).val()).trim());

        let searchTerm:string = <string>$(this.searchBoxId).val();
        if (searchTerm.length === 0) {
            return;
        }
        else if (/\d/.test(searchTerm)) {
            //test for any digits in the search term - if so we do a Postcode search
            this.findPostcode(searchTerm);
        } else {
            this.findLocation(searchTerm);
        }
    }

    private searchTwuid = (): void => {
        this.clearMarker();

        //trim it
        $(this.searchTwuidBoxId).val((<string>$(this.searchTwuidBoxId).val()).trim());        

        let searchTerm: string = <string>$(this.searchTwuidBoxId).val();
        if (searchTerm.length === 0) {
            return;
        }
        this.findTwuid(searchTerm);
    }

    private findPostcode = (searchTerm: string): void => {
        searchTerm = searchTerm.trim();
        // this caused issue #11
        //searchTerm = searchTerm.replace(/\s/g, "");        
        $("#gazLoading").show();
        this.find({
            //searchType: 1,
            query: searchTerm
        }, this.baseUrl, 14, this.processSearchResult);
    }

    private findLocation = (searchTerm: string): void => {
        $("#gazLoading").show();
        this.find(
            {
                //searchType: 2,
                query: searchTerm
            },
            this.baseUrl, 14, this.processSearchResult);
    }

    private findTwuid = (searchTerm: string): void => {
        let self = this;
        $("#twuidLoading").show();
        this.find({ query: searchTerm }, this.twuuidApiUrl, 14, processTwuidResult, this.showNoResultsOnTwuidFail);


        function processTwuidResult(json:any, zoomLevel: number) {
            console.log(json);
            $("#twuidLoading").hide();
            if (json.wkt) {
                let format = new WKT();
                let geom = format.readGeometry(json.wkt, {
                    dataProjection: "EPSG:27700",
                    featureProjection: "EPSG:3857"
                }); //parse WKT                
                let extent = geom.getExtent();
                self.map.getView().fit(extent, { maxZoom: 17, nearest: false });

                //let center = ol.extent.getCenter(extent);
                //map.getView().setCenter(center);
                //map.getView().setZoom(zoomLevel);
            }
            else {
                this.showTwuidNoResults();
            }
        }
    }

    private showNoResultsOnTwuidFail = (jqXHR, textStatus, errorThrown): void => {
        this.showTwuidNoResults();
    }
    private showTwuidNoResults = (): void => {
        $("#twuidLoading").hide();
        $("#twuidNoResults").show();
        setTimeout(function () {
            $("#twuidNoResults").hide();
        }, 3000);
    }

    private showNoResults = (): void => {
        $("#noResults").show();
        setTimeout(function () {
            $("#noResults").hide();
        }, 3000);
    }

    private alertOnFail = (jqXHR, textStatus, errorThrown): void => {
        $("#gazLoading").hide();
        alert("error");
    }
    private showNoResultsOnFail = (jqXHR, textStatus, errorThrown): void => {
        $("#gazLoading").hide();
        this.showNoResults();
    }

    private find = (dataObj, seachUrl: string, zoomLevel: Number, successFunction: Function, failFunction: any = null): void =>{
        $.ajax({
            url: seachUrl,
            data: dataObj,
            dataType: "json"
        })
            .done(function (json) {
                successFunction(json, zoomLevel);
            })
            .fail(
                function () {
                    if (failFunction !== null) {
                        failFunction.call(this);
                    }                    
                }                
            );            
    }

    //used to process location and postcode search results
    private processSearchResult = (json: any, zoomLevel: number): void => {
        let points = new Array(),
            location, point,
            resultsSelect;

        //remove all existing entries
        resultsSelect = $(this.resultsSelectId);
        resultsSelect.empty();
        resultsSelect.hide();
        $("#noResults").hide();
        $("#gazLoading").hide();

        //alert(json);
        //console.log(json.results);

        let queryFromHeader = null;
        if (json.header) {
            queryFromHeader = json.header.query.toLowerCase();
        }

        //keep track of ids so we can dedup
        let resultIds = {};

        if (json.results) {
            $.each(json.results, function (index, item) {

                // console.log(item);

                if (item.GAZETTEER_ENTRY.LOCAL_TYPE === "Postcode") {
                    console.log('postcode');
                    let location = {
                        Name: item.GAZETTEER_ENTRY.POPULATED_PLACE,
                        PostalCode: item.GAZETTEER_ENTRY.NAME1,
                        County: item.GAZETTEER_ENTRY.COUNTY_UNITARY,
                        Longitude: item.GAZETTEER_ENTRY.GEOMETRY_X,
                        Latitude: item.GAZETTEER_ENTRY.GEOMETRY_Y,
                        Region: item.GAZETTEER_ENTRY.REGION,
                        ZoomLevel: zoomLevel
                    };

                    //getting non-matching results, make sure NAME1 contains the search postcode
                    //remove all whitespace and force to LC for comparison
                    if (queryFromHeader && location.PostalCode.replace(/\s/g, "").toLowerCase().indexOf(queryFromHeader.replace(/\s/g, "")) > -1) {
                        points.push(location);
                    }


                } else {

                    //need to deduplicate, OS is returning multiple result, e.g. for cardiff
                    let id = item.GAZETTEER_ENTRY.ID;

                    if (!resultIds[id]) {
                        resultIds[id] = 1;

                        let location = {
                            Name: item.GAZETTEER_ENTRY.NAME1,
                            Name2: item.GAZETTEER_ENTRY.NAME2 || "",
                            County: item.GAZETTEER_ENTRY.COUNTY_UNITARY,
                            Longitude: item.GAZETTEER_ENTRY.GEOMETRY_X,
                            Latitude: item.GAZETTEER_ENTRY.GEOMETRY_Y,
                            ZoomLevel: zoomLevel
                        };

                        //If "REGION":"Wales" then use name2
                        if (item.GAZETTEER_ENTRY.REGION === "Wales" && item.GAZETTEER_ENTRY.NAME2) {
                            location.Name = item.GAZETTEER_ENTRY.NAME2;
                            location.Name2 = item.GAZETTEER_ENTRY.NAME1
                        }

                        //console.log(location);

                        //getting non-matching results, make sure NAME1 contains the search string
                        if (queryFromHeader &&
                            (location.Name.toLowerCase().indexOf(queryFromHeader) > -1 || location.Name2.toLowerCase().indexOf(queryFromHeader) > -1)) {
                            points.push(location);
                        }
                    }
                }
            });
        }

        function sortGaz(a, b) {
            let namea = a.Name + (a.County || "aa");
            let nameb = b.Name + (b.County || "aa");
            if (namea > nameb) return 1;
            if (nameb > namea) return -1;

            return 0;
        }
        points.sort(sortGaz);

        this.searchResults = new Array();

        if (points.length === 0) {
            //resultsSelect.append("<option>No results found</option>");
            this.showNoResults();

        } else if (points.length > 1) {
            for (let i = 0; i < points.length; i++) {
                point = points[i];
                if (point.PostalCode) {
                    if (point.Name) {
                        resultsSelect.append("<option>" + point.PostalCode + ", " + point.Name + ", " + point.Region + "</option>");
                    } else {
                        resultsSelect.append("<option>" + point.PostalCode + ", " + point.Region + "</option>");
                    }

                }
                else {
                    if (point.County) {
                        resultsSelect.append("<option>" + point.Name + " - " + point.County + "</option>");
                    } else {
                        resultsSelect.append("<option>" + point.Name + "</option>");
                    }

                }

                this.searchResults.push(point);
            }
            resultsSelect.show();

        } else if (points.length == 1) {
            //transform fails if there are only a few decimal places in  the result coords, force value to a float
            //let coord = [parseFloat(points[0].Easting), parseFloat(points[0].Northing)];
            //let coord3857 = ol.proj.transform(coord, 'EPSG:27700', 'EPSG:3857');
            //zoomLevel = 5;
            let coord = [parseFloat(points[0].Longitude), parseFloat(points[0].Latitude)];
            let coord3857 = olProj.transform(coord, 'EPSG:27700', 'EPSG:3857');

            //let coord27700 = ol.proj.transform(coord, 'EPSG:4326', 'EPSG:27700');
            //console.log('coord was ' + coord);
            //console.log('coord27700 was ' + coord27700);
            //console.log('zoomLevel was ' + zoomLevel);
            //map.getView().setCenter(coord27700);

            //map.getView().setCenter(coord);            
            //map.getView().setZoom(zoomLevel);
            this.map.getView().animate({ center: coord3857 }, { zoom: zoomLevel });

            //addMarker(coord27700);
        }
    }

    private showOnMap = (ddl): void => {
        let i = ddl.prop('selectedIndex');

        if (this.searchResults.length > 0 && (this.searchResults.length >= i)) {
            //transform fails if there are only a few decimal places in  the result coords, force value to a float
            //let coord = [parseFloat(searchResults[i].Easting), parseFloat(searchResults[i].Northing)];
            //let coord3857 = ol.proj.transform(coord, 'EPSG:27700', 'EPSG:3857');

            let coord = [parseFloat(this.searchResults[i].Longitude), parseFloat(this.searchResults[i].Latitude)];
            let coord3857 = olProj.transform(coord, 'EPSG:27700', 'EPSG:3857');

            //map.getView().setCenter(coord27700);
            ////map.getView().setCenter(coord);
            //map.getView().setZoom(searchResults[i].ZoomLevel);
            this.map.getView().animate({ center: coord3857 }, { zoom: this.searchResults[i].ZoomLevel });

            //addMarker(coord3857);
            this.hideSearchResultBox();
        }
    }

    private clearMarker = (): void => {
        this.vectorSource.clear(true);
    }

    private addMarker = (coords): void => {
        this.vectorSource.clear(true);

        let iconStyle = new Style({
            image: new Icon(({
                anchor: [0.5, 1],
                anchorXUnits: IconAnchorUnits.FRACTION,
                anchorYUnits: IconAnchorUnits.FRACTION,
                opacity: 0.95,
                src: '/iGIGL/Content/Images/marker-icon-blue.png'
            }))
        });

        let feature = new Feature({
            geometry: new Point(coords)
        });
        feature.setStyle(iconStyle);
        this.vectorSource.addFeature(feature);
    }

}